<div class="border-0 px-4 py-1 scroll-container" ref="PermissionManagement">
  <NavigationBackButton />
  <div class="card-header card-header-primary card-nav-tabs shadow rounded-lg mt-2">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="rounded-lg me-2 nav-item">
              <a class="text-white text-decoration-none text-x fw-bold nav-link" href="#profile" data-toggle="tab">
                Assigning Applications
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <div class="card rounded-lg border-0 shadow mt-2">
    <div class="card-body p-3 pt-2 bg-white rounded-lg">


<div class="bg-white pb-2">

    <div class="mt-4 d-flex pe-3 justify-content-end">
        <button class="btn btn-primary-dark btn-sm text-xxs shadow" data-bs-toggle="modal"
        data-bs-target="#assign_application" @click="open_assign_modal">
        Assign Personnel
        </button>
    </div>

</div>

<!-- Assigned Users List -->
<div
  class="assigned-users-list mt-3 border-shadow sm"
  v-if="assigned_rows.length > 0"
>
  <div
    class="assigned-user-card d-flex justify-content-between align-items-center p-3 mb-2 border shadow-sm rounded-3"
    v-for="(user, index) in assigned_rows"
    :key="user.id"
  >
    <div class="d-flex align-items-center gap-3">
      <i class="bi bi-folder2 fs-4 text-secondary"></i>
      <div>
        <div>
  <p class="mb-0 text-xs fw-bold text-dark">
    Name:
    <span class="fw-normal text-muted">{{ user.assigned_to_name || '—' }}</span>
  </p>
  <p class="mb-0 text-xs fw-bold text-dark">
    Role:
    <span class="fw-normal text-muted">{{ user.role_name || '—' }}</span>
  </p>
  <p class="mb-0 text-xs fw-bold text-dark">
    Status:
    <span class="fw-normal text-muted">{{ user.status_name || '—' }}</span>
  </p>
  <p class="mb-0 text-xs fw-bold text-dark">
    Date Assigned:
    <span class="fw-normal text-muted">{{ user.formatted_date_assigned || '—' }}</span>
  </p>
</div>

      </div>
    </div>
    <button
      class="tn btn-primary-dark btn-sm text-xxs shadow"
      @click="unassign_user(user)"
    >
      Unassign
    </button>
  </div>
</div>

<!-- When there are no assigned users -->
<p
  v-else
  class="text-muted text-center text-xs mt-3"
>
  No users assigned yet.
</p>


<!-- Assign Application Modal -->
 <teleport to="body">
<div class="modal" id="assign_application" tabindex="-1" aria-labelledby="assign_application_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
        <h5 class="modal-title text-white text-xxs m-0" id="assign_application_modal_label">Assign Personnel</h5>
        <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-3">
        <!-- Role select -->
        <div class="modal-form-group form-group mb-3">
          <label for="assign_application_select" class="modal-form-label form-label text-xxs">Roles</label>
          <select
            id="assign_application_select"
            class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm"
            v-model="assign_selected_role_id"
            @change="on_role_change"
          >
            <option value="" disabled hidden>Select Role</option>
            <option v-for="role in available_roles" :key="role.id" :value="role.id">
              {{ role.role }}
            </option>
          </select>
        </div>

        <!-- Users table -->
        <!-- Messages ABOVE the table -->
        <p v-if="is_loading_users" class="text-muted text-xs mb-2">Loading users…</p>
        <p v-else-if="!is_loading_users && table_safe_form_list.length === 0" class="text-muted text-xs mb-2">
        {{ assign_selected_role_id ? 'No users found for this role' : 'Select a role to view users' }}
        </p>

        <!-- Only render table when we have real rows -->
        <div class="table-responsive" v-if="table_safe_form_list.length > 0">
        <table
            class="table table-hover"
            id="assign_users_table"
            ref="assignUsersTable"
            :key="table_key"
        >
            <thead class="custom-header">
            <tr>
                <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">No</th>
                <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Name</th>
                <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Email</th>
                <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Assign</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user, index) in table_safe_form_list" :key="user.id" class="text-xxs">
                <td class="text-xs text-start">{{ index + 1 }}</td>
                <td class="text-xs text-start">{{ user.user_name || '' }}</td>
                <td class="text-xs text-start">{{ user.email || '—' }}</td>
                <td class="text-xs text-start">
                <div class="d-flex justify-content-center align-items-center gap-2">
                    <div class="form-check form-switch m-0">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        :id="'assign-toggle-' + user.id"
                        v-model="user.is_assigned"
                        :disabled="user.is_loading"
                        @change="toggle_assignment(user)"
                    />
                    </div>
                    <span class="badge" :class="user.is_assigned ? 'bg-success' : 'bg-secondary'">
                    {{ user.is_assigned ? 'Assigned' : 'Unassigned' }}
                    </span>
                </div>
                </td>
            </tr>
            </tbody>
        </table>
        </div>


      </div>

      <!-- Footer -->
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
      </div>
    </div>
  </div>
</div>
</teleport>

    </div>
  </div>
</div>